import React from 'react';
import dynamic from 'next/dynamic';
import { Box, Tabs as MuiTabs } from '@mui/material';

const Tab = dynamic(() => import('./Tab'));

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

export const Tabs = ({
  value,
  onChange,
  tabs,
  children,
  styles = {},
  borderStyles = {},
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        overflow: 'auto',
        width: '100%',
        ...styles,

        '& .MuiTabs-indicator': {
          height: '4px',
        },
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          width: '100%',
          padding: '0 20px',

          ...borderStyles,
        }}
      >
        <MuiTabs
          value={value}
          onChange={onChange}
          aria-label="basic tabs example"
          variant="scrollable"
        >
          {tabs.map((item, index) => (
            <Tab key={item.label} {...item} {...a11yProps(index)} />
          ))}
        </MuiTabs>
      </Box>
      {children}
    </Box>
  );
};

export default Tabs;
